// The Benefit Bay wind-down (2026-10-01): clients of the Benefit Bay (ICHRA)
// employers were soft-deactivated with `deactivated_reason = 'former_ichra'`
// and every surface that can still reach them shows this one message.
// flow/scheduling/coverage.py holds the same string; change both.
// Spec: docs/superpowers/specs/2026-09-24-former-ichra-soft-deactivation-design.md

export const FORMER_ICHRA = 'former_ichra'

export const FORMER_ICHRA_MESSAGE = "Doctor's Choice no longer has a partnership through your employer. Please contact HR for information about the Medicare support options available to you."

// A client record (search result, survey payload, scheduler row) closed by the
// wind-down. False for active clients and for every other inactive one.
export function isFormerIchra (record) {
    return !!record && record.active === false && record.deactivated_reason === FORMER_ICHRA
}

// The 125 clients the wind-down KEPT on purpose (they hold a commissionable plan
// with us) stay active in a group marked config.former_ichra, and still carry
// ICHRA/BenefitBay, so advisors took them for clients who slipped through
// (Dien, 2026-11-05). This label says why they are still served.
export const KEPT_FORMER_ICHRA_LABEL = 'Kept after Benefit Bay'
export const KEPT_FORMER_ICHRA_TOOLTIP = "Benefit Bay ended on 10/1/2026. Doctor's Choice kept this client on purpose because they hold a commissionable plan with us."

// An active client of a former Benefit Bay group. Search rows carry the
// backend's group_former_ichra; survey payloads carry the group with its config.
export function isKeptFormerIchra (record) {
    if (!record || record.active === false) return false
    if (record.group_former_ichra) return true
    const group = record.group
    return !!(group && typeof group === 'object' && group.config && group.config.former_ichra)
}
